import { apiClient } from '@/api/client';

export type PublicAssetPurpose = 'avatar' | 'product' | 'service' | 'gallery' | 'storefront' | 'offer' | 'branding';
const purposes: readonly string[] = ['avatar', 'product', 'service', 'gallery', 'storefront', 'offer', 'branding'];

/** Only deliberately public media uses this endpoint. Private documents use private-assets grants. */
export function uploadPublicAsset(formData: FormData, purpose: PublicAssetPurpose, providerId?: number, tenantId?: number) {
  if (!purposes.includes(purpose)) throw new Error('An explicit public asset purpose is required');
  if (providerId !== undefined && (!Number.isSafeInteger(providerId) || providerId <= 0)) throw new Error('Invalid business scope');
  if (tenantId !== undefined && (!Number.isSafeInteger(tenantId) || tenantId <= 0)) throw new Error('Invalid tenant scope');
  return apiClient.post<{ filePath: string; fullUrl?: string }>('/uploads', formData, {
    params: { purpose, ...(providerId === undefined ? {} : { providerId }) },
    headers: { 'Content-Type': 'multipart/form-data', ...(tenantId === undefined ? {} : { 'X-Impersonate-Tenant': String(tenantId) }) },
  });
}

